import { createSelector } from '@ngrx/store';

import { wizzardState } from '../root';

export const getWizzardSimpleItemTotalValue = createSelector(wizzardState, (wizzard) =>
    wizzard.itemsSimple ? wizzard.itemsSimple.Quantity * wizzard.itemsSimple.UnitPrice : null,
);
